module.exports = __webpack_public_path__ + "img/Hayes.907e47e1.jpg";